import { makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = (warning: boolean) => makeStyles((theme) => ({
    container: {
        alignSelf: "start",
        minWidth: "180px",
        minHeight: "80px",

        padding: "20px 28px",
        display: "flex",
        alignItems: "stretch",
        justifyContent: "stretch",

        backgroundColor: warning ? theme.palette.error.light : theme.palette.background.paper,
        border: `1.5px solid ${warning ? theme.palette.error.main : theme.palette.divider}`,
        borderRadius: "16px",
        boxShadow: warning
            ? "0 4px 16px rgba(234, 80, 71, 0.1)"
            : "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)",
        transition: "box-shadow 0.2s ease",
        "&:hover": {
            boxShadow: warning
                ? "0 6px 20px rgba(234, 80, 71, 0.15)"
                : "0 4px 12px rgba(0, 0, 0, 0.08)",
        },
    },
    summary: {
        flexGrow: 1,
        display: "grid",
        gridTemplateColumns: "1fr 0.5fr",
        gap: "8px",
        alignItems: "end",
    },
    count: {
        fontSize: "64px",
        fontWeight: 600,
        lineHeight: 0.85,
        color: warning ? theme.palette.error.main : theme.palette.primary.main,
        letterSpacing: "-0.02em",
    },
    descr: {
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.06em",
        textTransform: "uppercase" as const,
        width: "90px",
        color: warning ? theme.palette.error.dark : theme.palette.text.secondary,
        lineHeight: 1.3,
    },
}));

interface Props {
    label: string;
    count: number;
    attentionToCount?: boolean;
}

export function StatsSummary({
    label,
    count,
    attentionToCount = false,
}: Props) {
    const warning = attentionToCount && count > 0
    const classes = useStyles(warning)();

    return (
        <div className={classes.container}>
            <div className={classes.summary}>
                <Typography className={classes.count}>{count}</Typography>
                <Typography className={classes.descr}>{label}</Typography>
            </div>
        </div>
    );
}